import {
  createResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const EQUIPMENT_MODEL = 'equipment'

const EQUIPMENT_REQUEST_CREATE = prefixAPI('/request/create/', EQUIPMENT_MODEL)

export const equipmentCreateRequest = createResource(EQUIPMENT_REQUEST_CREATE, postResource)
